import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

const navItems = [
  { to: '/', label: '首页' },
  { to: '/episodes', label: '剧集' },
  { to: '/actors', label: '演员' },
  { to: '/news', label: '资讯' },
  { to: '/about', label: '关于' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5 group">
            <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-movie-2-line text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                女友的妈妈
              </span>
              <span className="text-[10px] tracking-[0.2em] text-foreground-500 mt-0.5">
                DRAMA 专题站
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-sm transition-colors ${
                    isActive
                      ? 'text-accent-700 bg-accent-100 font-medium'
                      : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden md:block">
            <Link
              to="/episodes"
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
            >
              <i className="ri-play-list-2-line"></i>
              立即追剧
            </Link>
          </div>

          <button
            type="button"
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800 cursor-pointer"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开导航菜单"
          >
            <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
          </button>
        </div>
      </div>

      {open && (
        <nav className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3 flex flex-col gap-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `px-4 py-3 rounded-md text-sm ${
                  isActive
                    ? 'bg-accent-100 text-accent-700 font-medium'
                    : 'text-foreground-700'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/episodes"
            onClick={() => setOpen(false)}
            className="mt-2 inline-flex items-center justify-center gap-1.5 px-4 py-3 rounded-md text-sm bg-primary-500 text-background-50"
          >
            <i className="ri-play-list-2-line"></i>
            立即追剧
          </Link>
        </nav>
      )}
    </header>
  );
}